module.exports = __webpack_public_path__ + "static/media/pix.0e77920f.png";